// extracted by mini-css-extract-plugin
module.exports = {"first":"HeaderTitle_first__RK0yo","second":"HeaderTitle_second__3XdqL","third":"HeaderTitle_third__1P5Nb","four":"HeaderTitle_four__1pWUF"};